import { useEffect, useState } from "react";

/**
 * Возвращает значение, обновляемое не чаще чем раз в `delay` мс после последнего изменения `value`.
 * @template T тип значения
 * @param value исходное значение
 * @param delay задержка в миллисекундах
 */
export function useDebounce<T>(value: T, delay: number): T {
    const [debouncedValue, setDebouncedValue] = useState<T>(value);

    useEffect(() => {
        const handler = window.setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            window.clearTimeout(handler);
        };
    }, [value, delay]);

    return debouncedValue;
}
